import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import Loading from '../../../Elements/loading';
import AssignmentService from '../../../Services/AssignmentService';
import AssignmentSearchParams from './AssignmentSearchParams';
import AssignmentItem from '../../../Domain/AssignmentItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditAssignmentWindowDescription from './EditAssignmentWindowDescription';
import LookupItemService from '../../../Services/LookupItemService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import ShowAssignmentAssignmentPaymentsOverDataWindow from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/ShowAssignmentAssignmentPaymentsOverDataWindow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ProjectAssignmentService from '../../../Services/ProjectAssignmentsService';
import ProjectAssignmentEditItem from '../../../Domain/ProjectAssignmentEditItem';
import paidOutsideOfSystemHelper from '../../../Helpers/paidOutsideOfSystemHelper';

class AssignmentAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      loading: false,
      selected: -1,
      selectedItem: null,
      selectedItemExtended: null,
      orderBy: 'AsId',
      orderDirection: OrderDirectionsEnum.Desc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel: ShownPanelsEnum.None,
      searchItem: AssignmentAdmin.buildInitialSearchItem(),
      extendedLoading: false,
      selectedAssignment: null,
    };

    this.startSearch = this.startSearch.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    AssignmentItem.editFunction = this.clickOnEditIcon.bind(this);
    AssignmentItem.assignmentPaymentsFunction = this.assignmentPaymentsFunction.bind(this);
    AssignmentItem.paidOutsideOfSystemFunction = this.paidOutsideOfSystemFunction.bind(this);
    this.closeOverWindow = this.closeOverWindow.bind(this);
  }

  // Deep-link seed for global record search (CD-5425). A shop has no name, so the palette seeds the
  // Sassie assignment id it displayed - the grid's own numeric branch matches that id exactly, landing
  // on the single row rather than re-running a fuzzy search the user already narrowed.
  // content.js renders a deep-linked page with no props, so the URL is the only channel.
  static buildInitialSearchItem() {
    const searchItem = new AssignmentSearchParams();
    const seededAssignmentId = new URLSearchParams(window.location.search).get('AsSassieAsgnId');

    if (seededAssignmentId) {
      searchItem.AsSassieAsgnId = seededAssignmentId;
    }

    return searchItem;
  }

  // CD-5421: the single-row toggle, mirroring TpJobAdmin. Posts through the same bulk endpoint the project
  // assignment lists use, with a one-element id list, so there is only one write path and one server check.
  paidOutsideOfSystemFunction(assignment) {
    const turningOn = !AssignmentItem.isPaidOutsideOfSystem(assignment);
    const message = paidOutsideOfSystemHelper.GetToggleConfirmationMessage(
      turningOn,
      'assignment',
      assignment.AsSassieAsgnId,
      'shopper fee'
    );

    ErrorMessage.SetApprove(message, () => this.applyPaidOutsideOfSystem(assignment, turningOn));
  }

  applyPaidOutsideOfSystem(assignment, paidOutsideOfSystem) {
    ProjectAssignmentService.EditMultipleAssignment(
      ProjectAssignmentEditItem.createPaidOutsideOfSystemItem(paidOutsideOfSystem),
      [assignment],
      false,
      // Only read server-side when "all items in the search are selected", which this never is.
      {}
    )
      .then(() => {
        this.setState({ searchItem: { ...this.state.searchItem } });
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: AA5421');
      });
  }

  closeOverWindow() {
    this.setState({ shownOverWindow: ShownOverWindowsEnum.None });
  }

  async assignmentPaymentsFunction(assignment) {
    this.setState({ extendedLoading: true });
    const assignmentData = await AssignmentService.GetAssignmentById(assignment.AsId);
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.EvaluatorPayments,
      selectedAssignment: assignment,
      selectedItemExtended: assignmentData,
      extendedLoading: false,
    });
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: { ...searchItem },
    });
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ...this.state.searchItem },
    });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItemExtended}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditAssignmentWindowDescription}
            errorCode={'AA83'}
          />
        )}
      </div>
    );
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: refresh,
    });
    if (refresh) {
      this.setState({ searchItem: { ...this.state.searchItem } });
    }
  }

  async clickOnEditIcon(selectedId, selectedItem) {
    this.setState({ extendedLoading: true });

    const assignmentData = await AssignmentService.GetAssignmentById(selectedItem.AsId);
    assignmentData.isApprovedEnabled = assignmentData.isApproved === 0 || assignmentData.isApproved === 1;
    assignmentData.isApprovedHidden = assignmentData.isApproved === 0 || assignmentData.isApproved === 1;

    const enumType = ShownPanelsEnum.EditItem;

    if (assignmentData.ciStatusCode === 1 || assignmentData.ieStatusCode === 1) {
      const invStatus = await LookupItemService.GetLookupItemByLookupIdAndLookupValue(43, assignmentData.ciStatusCode);
      assignmentData.invoiceStatus = invStatus.text;

      const evPaymentStatus = await LookupItemService.GetLookupItemByLookupIdAndLookupValue(
        45,
        assignmentData.ieStatusCode
      );
      assignmentData.evaluatorPaymentStatus = evPaymentStatus.text;
    }

    this.setState({
      selectedItem,
      selectedItemExtended: assignmentData,
      shownPanel: enumType,
      extendedLoading: false,
    });
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.EvaluatorPayments) {
      return this.state.extendedLoading ? (
        <Loading />
      ) : (
        <ShowAssignmentAssignmentPaymentsOverDataWindow
          assignment={this.state.selectedItemExtended}
          clickOnCancel={this.closeOverWindow}
        />
      );
    }

    return null;
  }

  render() {
    return this.state.extendedLoading ? (
      <Loading />
    ) : (
      <div className='contentwrapper'>
        {this.renderPanels()}
        <TabOfDataTable
          type={AssignmentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={AssignmentService.GetAssignmentList}
          convertDBItemsFunction={AssignmentService.ConvertDBItemList}
          searchItem={this.state.searchItem}
          searchParamsType={AssignmentSearchParams}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different ids, names and country code...'
          errorCode='AA140'
        />
        {this.renderOverWindows()}
      </div>
    );
  }
}

export default AssignmentAdmin;
